// To generate a new file similar to this one, run `pay js:run gql-v1 --type=query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import {gql} from '@sail/data';
import {useV1Query} from '@stripe-internal/data-v1';

import type {GraphQlDocument} from '@sail/data';

import type {
  V1QueryOptions,
  V1QueryOptionsWithoutVariables,
  V1QueryReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';

import type {
  Exact,
  InputMaybe,
  OpenapiGetV1CryptoInternalWalletBalancesInput,
  V1ContextInput,
  OpenapiCryptocurrencyPayinsResourceTokenBalanceNetworkEnum,
} from '@stripe-internal/data-v1/schema/types';

const doc = gql`
  query WalletBalancesQuery(
    $input: OpenapiGetV1CryptoInternalWalletBalancesInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalWalletBalances(input: $input, v1Context: $v1Context) {
      balances {
        balance
        minorUnits: minor_units
        network
        rawBalance: raw_balance
        tokenAddress: token_address
      }
    }
  }
`;

export const walletBalancesQuery: WalletBalancesQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const walletBalancesQueryOptions: V1QueryOptionsWithoutVariables<WalletBalancesQueryDocument> =
  {
    // expectedErrors: [],
    // mutedErrors: [],
    // fetchPolicy: 'cache-first',
    // ...
  };

export default function useWalletBalancesQuery(
  options: V1QueryOptions<WalletBalancesQueryDocument>,
): V1QueryReturn<WalletBalancesQueryDocument> {
  return useV1Query(walletBalancesQuery, {
    ...walletBalancesQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type WalletBalancesQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1CryptoInternalWalletBalancesInput>;
  v1Context: V1ContextInput;
}>;

export type WalletBalancesQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalWalletBalances: {
    readonly __typename: 'OpenapiCryptocurrencyPayinsResourceWalletTokenBalances';
    readonly balances: ReadonlyArray<{
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceTokenBalance';
      readonly balance: string;
      readonly network: OpenapiCryptocurrencyPayinsResourceTokenBalanceNetworkEnum;
      readonly minorUnits: number;
      readonly rawBalance: string;
      readonly tokenAddress: string;
    }>;
  } | null;
};

export type WalletBalancesQueryToken = AccountToken<{
  Query_v1CryptoInternalWalletBalances: true;
}>;

export type WalletBalancesQueryDocument = GraphQlDocument<
  WalletBalancesQueryData,
  WalletBalancesQueryVariables,
  WalletBalancesQueryToken
>;
